// Industry-aware Silent Auction Power Up demo templates.
// Produces the production UI's dollar/cents aliases and lifecycle fields.

import { getPowerUpProfile } from "../../../industries/power_up_profiles";

export const buildAuctionDefaults = ({
  industryTemplate = "car_show",
  demoSize = "medium",
} = {}) => {
  const pool = getPowerUpProfile(industryTemplate).auctionItems;
  const limit = getAuctionLimit(demoSize, pool.length);

  // Large demos need more than one 12-card preview page to exercise bulk QR
  // filtering, pagination, and Print All. Repeated donations have distinct lots.
  const lots = Array.from({ length: limit }, (_, index) => pool[index % pool.length]);
  return lots.map(([baseTitle, donorName], index) => {
    const title = index >= pool.length ? `${baseTitle} — Lot ${index + 1}` : baseTitle;
    const startingBidCents = 2500 + (index * 1500);
    const minimumIncrementCents = index > 1 ? 1000 : 500;
    const status = index === 0 || index === 3 ? "open" : index === 2 ? "closed" : "draft";
    const quantityAvailable = index === 2 ? 2 : 1;

    return {
      demoKey: `auction-item-${index + 1}`,
      sourceType: index === 0 ? "entry" : "standalone",
      linkedEntryId: "",
      linkedEntryCollection: "",
      linkedEntryLabel: "",
      title,
      description: `${title}, generously provided by ${donorName} to support this event.`,
      donorName,
      auctionNotes: "Present your paid paper or digital receipt at the auction pickup table. Winners not present will be contacted via email to arrange hand-over.",
      startingBid: startingBidCents / 100,
      startingBidCents,
      minimumIncrement: minimumIncrementCents / 100,
      minimumIncrementCents,
      bidIncrementCents: minimumIncrementCents,
      currentBid: 0,
      currentBidCents: 0,
      bidCount: 0,
      status,
      // Event-level Auction Timer owns all public start/end transitions.
      // Do not seed item-specific clocks that conflict with the demo event.
      active: status === "open",
      published: status !== "draft",
      featured: index < 2,
      imageUrl: "/images/social-share-silent-auctions.png",
      imageUrls: ["/images/social-share-silent-auctions.png", "/images/og-default.png"],
      displayOrder: (index + 1) * 10,
      quantityAvailable,
      maxUnitsPerBidder: 1,
      allocationMethod: "top_unique_bidders",
      unitsAwarded: 0,
      currentWinnerUid: "",
      currentWinnerName: "",
      currentWinnerEmail: "",
      winningBidId: "",
      paymentStatus: status === "closed" ? "unpaid" : "not_required",
      pickupStatus: status === "closed" ? "awaiting_payment" : "not_ready",
      pickedUp: false,
      demoSeed: true,
    };
  });
};

const getAuctionLimit = (demoSize, maxCount) => {
  switch (demoSize) {
    case "small":
      return Math.min(4, maxCount);
    case "large":
      return 13;
    case "xlarge":
      return 20;
    case "medium":
    default:
      return Math.min(5, maxCount);
  }
};
